import React from 'react';
import api from '../../api/api';
import util from '../../util/util';
import Item from '../../reusable/item';
import MessageModal from '../../reusable/messaging-modal';
import Layout from '../../reusable/layout';
import Pricing from '../../reusable/pricing';
import EventEmitter from '../../reusable/publisher';
import $ from 'jquery';
import {slideShows, loadTip} from 'sbtools';
import 'babel-polyfill';

export default class HomeContainer extends React.Component {
	constructor(props) {
		super(props);
		
		this.state = {
			searchTerm: '',
			itemList: [],
			canShowModal: false,
			modalName: '',
			modalReceiverID: 0,
		}
		
	}
	
	componentWillMount() {
		this.submitSearch(1);
	}
	
	componentDidMount() {
		setTimeout(function(){slideShows(document);}, 200);
	}
	
	showModal(modalInfo){
        this.setState({
            modalName: modalInfo.Name,
            modalReceiverID: modalInfo.ReceiverID,
            canShowModal: true,
        });
    }
	
	closeModal() {
        this.setState({
            modalName: '',
            modalReceiverID: 0,
            canShowModal: false,
        });
    }
	
	submitSearch(Page){
        let searchData = {
            method: 'ListItemsJS', 
            CategoryGroupID: -999, 
            SearchTerm: '', 
            Page: Page, 
            RecordsPerpage: 4,
            Status: 1,
            AccountID: accountID
        }
		this.setState({
			itemList: Page === 1 ? [] : this.state.itemList,
			Page: Page
		}, () => {
			api.StoreService(searchData).end((err, res) => {
				var result = JSON.parse(res.text);
				var Items = util.convertCFJSON(result.Items);
				let newItemList = this.state.itemList;
				for(var i=0; i<Items.length; i++){
					if(!util.InObjArray(newItemList, 'ITEMID', Items[i].ITEMID) && Items[i].ACCOUNTID != 21){
						Items[i].ISAD = false;
						newItemList.push(Items[i]);
					}
				}
				this.setState({
					itemList: newItemList
				});
			});
		});
    }
	
	handleSearchChange(e) {
		this.setState({
			searchTerm: this.refs.searching.value
		})
		EventEmitter.dispatch('updateHeaderText', this.refs.searching.value)
	}
	
	createItem(item, i){
        return (
            <Item key={i} itemData={item} showModal={this.showModal.bind(this)} isHome={true} />
        )
    }
	
	render() {
		let canShowModal = this.state.canShowModal ? <MessageModal ReceiverID={this.state.modalReceiverID} Name={this.state.modalName} closeModal={this.closeModal.bind(this)}/> : '';
		return(
			<Layout>
				<div>
					<div id="coverImage">
						<section className="clearfix">
							<h1 className="text-centered col-8">Search products made by Individuals like You!</h1>
							<p className="col-8">Simply tell us what you are looking for.</p>
							<div className="col-8 searchBar">
								<form action="/searchResults.cfm" method="post" encType="multipart/form-data">
									<label className="col-8 col-xs-6" htmlFor="search">You Type it, We'll find it! :)</label>
									<input type="text" className="col-8 col-xs-6" ref="searching" name="searchField" value={this.state.searchTerm} onChange={this.handleSearchChange.bind(this)} autoComplete="off"/>
									<button className="searchBtn col-4 col-xs-6" type="submit">Start Searching</button>
								</form>
							</div>
						</section>
					</div>
					<div id="homeFeatured">
						<section className="clearfix" id="FloralCont">
							<h1 className="text-centered col-12 raleway col-xs-11" style={{color: '#666', float: 'none'}}>
								We are on a mission to<br/>
								<span className="raleway">Make Your Artistic Dreams a Reality</span>
							</h1>
						</section>
						<section className="clearfix">
							<h2 className="text-centered">RECENTLY ADDED ITEMS<br/>
								<span className="subTitle">ITEMS RECENTLY ADDED ON WUBART</span>
							</h2>
							<hr/>
							<div className="col-12 clearfix">
								{this.state.itemList.map(this.createItem.bind(this))}
							</div>
						</section>
					</div>
					<HomeLinks />
					<div className="col-12 pink diamondPattern">
						<section className="clearfix">
							<h2 className="text-centered col-12 text-white raleway">Meet the Team</h2>
							<div className="col-12 slideContainer">
								<ul className="slideshow" data-time="7000" data-nav="true">
									<li>
										<div className="profilePhoto Male" id="photoPro"></div>
										<h4 className="text-centered col-12 text-white raleway">
											Sean Bartlett (Owner, Web Developer/Designer)
										</h4>
										<h3 className="text-centered col-12 text-white raleway">
											"We are driven to providing the best marketplace experience for both sellers and shoppers."
										</h3>
									</li>
									<li>
										<div className="profilePhoto Female" id="photoPro"></div>
										<h4 className="text-centered col-12 text-white raleway">
											Danielle Moore (Graphic Designer, Marketing Manager)
										</h4>
										<h3 className="text-centered col-12 text-white raleway">
											"We are Designing a better tomorrow."
										</h3>
									</li>
								</ul>
							</div>
						</section>
					</div>
					<Pricing home={true} />
				</div>
				{canShowModal}
			</Layout>
		)
	}
}

class HomeLinks extends React.Component {
	constructor(props) {
		super(props);
		
		this.state = {}
		
	}
	
	render() {
		return (
			<div className="col-12">
				<section className="howItWorks-sections clearfix" style={{textAlign: 'center', margin: '50px auto'}}>
					<div className="large-header">What is WubArt?</div>
					<div className="short-bar"></div>
					<span className="subTitle">We're an Artists and Crafters Marketplace and More.</span><br/><br/>
					<ol>
						<li className="home">
							<div className="small-header"><b>About Wubart</b></div><br/><br/>
							Learn more about WubArt, our mission and how we got started.<br/><a href="/about.cfm">Learn About Us</a>
						</li>
						<li className="home">
							<div className="small-header"><b>How Does it Work?</b></div><br/><br/>
							We have made it very easy to start selling online with WubArt.<br/><a href="/howItWorks.cfm">Learn How It Works</a>
						</li>
						<li className="home">
							<div className="small-header"><b>Keeping you Safe</b></div><br/><br/>
							If anything goes wrong, we've got your back. We've go security experts working to safeguard your information.<br/><a href="/signup.cfm">Open your Shop</a>
						</li>
					</ol>
				</section>
			</div>
		)
	}
}

class TabbedArea extends React.Component {
	constructor(props) {
		super(props);
		
		this.state = {
			currentTab: 'new'
		}
		
	}
	
	handleClick(tab){
		this.setState({
			currentTab: tab
		})
	}
		
	render() {
		
		let newClass = this.state.currentTab === 'new' ? ' active' : '';
		let expertClass = this.state.currentTab === 'expert' ? ' active' : '';
		let needHelpClass = this.state.currentTab === 'needHelp' ? ' active' : '';
		
		return(
			<section className="clearfix">
				<div className="col-12">
					<br/><br/>
					<div className="col-7 clearfix" id="tabMenu">
						<button className={'col-4 tab' + newClass} type="button" onClick={this.handleClick.bind(this, 'new')}>New to selling online?</button>
						<button className={'col-4 tab' + expertClass} type="button" onClick={this.handleClick.bind(this, 'expert')}>Online Sales Expert?</button>
						<button className={'col-4 tab' + needHelpClass} type="button" onClick={this.handleClick.bind(this, 'needHelp')}>Need help adding items?</button>
					</div>
				</div>
				<div className="col-12">
					<ul className="col-10 clearfix" id="tabContent">
						<li id="new" className={newClass}>
							<br/>
							<h2 className="text-centered">New to selling online? We can Help!<br/>
								<span className="subTitle">WUBART is the perfect place for newbies!!</span>
							</h2>
							<br/>
							<div className="col-7">
								<p>You don't need to have any technical or design experience to easily create a beautiful online store.</p>
							</div>
							<div className="col-5">
								<p><span>No need to hire a designer or take wed design classes. We will provide you with everything you need to make your online marketplace grab the attention of your customers.</span></p>

								<p>Simply upload a great cover image, add items and you're all set. All you have to do is wait for the sales to come rolling in. If you have any Questions, a member of our <a href="/support.cfm"><span>support staff</span></a> is waiting to answer.</p>

								<p></p>
							</div>
						</li>
						<li id="expert" className={expertClass}>
							<br/>
							<h2 className="text-centered">So You're an Online Sales Expert?<br/>
								<span className="subTitle">Find out why WUBART is the best place to grow your business!</span>
							</h2>
							<br/>
							<div className="col-7">
								<p>You don't need to have any technical or design experience to easily create a beautiful online store.</p>
							</div>
							<div className="col-5">
								<p><span>No need to hire a designer or take wed design classes. We will provide you with everything you need to make your online marketplace grab the attention of your customers.</span></p>

								<p>Simply upload a great cover image, add items and you're all set. All you have to do is wait for the sales to come rolling in. If you have any Questions, a member of our <a href="/support.cfm"><span>support staff</span></a> is waiting to answer.</p>

								<p></p>
							</div>
						</li>
						<li id="needHelp" className={needHelpClass}>
							<br/>
							<h2 className="text-centered">Need help adding items to your Marketplace?<br/>
								<span className="subTitle">We have simple help tips to get you on your way.</span>
							</h2>
							<br/>
							<div className="col-7">
								<p>You don't need to have any technical or design experience to easily create a beautiful online store.</p>
							</div>
							<div className="col-5">
								<p><span>No need to hire a designer or take wed design classes. We will provide you with everything you need to make your online marketplace grab the attention of your customers.</span></p>

								<p>Simply upload a great cover image, add items and you're all set. All you have to do is wait for the sales to come rolling in. If you have any Questions, a member of our <a href="/support.cfm"><span>support staff</span></a> is waiting to answer.</p>

								<p></p>
							</div>
						</li>
					</ul>
				</div>
			</section>
		)	
	}
}


/** WEBPACK FOOTER **
 ** ./app/home/components/home-container.js
 **/